import { createFileRoute } from '@tanstack/react-router';
import { JobDetailPage } from '@/pages/job/ui/JobDetailPage';

/**
 * ジョブ詳細ルート
 */
export const Route = createFileRoute('/_protected/job/$jobId')({
  component: JobDetailPage,
});
